<script setup>
import BrandChannelHeader from "./BrandChannelHeader";
import BrandChannelFooter from "./BrandChannelFooter";
import BrandChannelPlayer from "./BrandChannelPlayer";
import BrandChannelContent from "./BrandChannelContent";
import { isEmpty } from "lodash";
import { ref, onMounted } from 'vue';
import { useBrandChannelStore, useGlobalStateStore } from '../../store';

const brandChannelStore = useBrandChannelStore();
const globalStateStore = useGlobalStateStore();

const tape = ref({})
const brandChannel = ref({})
const tapeReady = ref(false)

onMounted((async () => {
  await loadEnvCorrect();

  tape.value = brandChannelStore.tape
  brandChannel.value = brandChannelStore.tape.brand_channel
  tapeReady.value = !isEmpty(brandChannelStore.tape);

  globalStateStore.setUUID()
  globalStateStore.setGlobalStateDefault()
}));

async function loadEnvCorrect() {
  console.log(process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging') {
    var path = window.location.pathname
      .replace('/home', '')
      .replace('/video', '');
    var query = { id: window.location.search.replace('?id=', '') };
    await brandChannelStore.load({
      path,
      query,
    })
  } else {
    await brandChannelStore.loadDev()
  }
}

</script>

<template>
  <div id="main" v-if="tapeReady">
    <BrandChannelHeader />
    <section v-if="!brandChannel.background" class="main-content clearfix">
      <div class="container">
        <div class="col-left">
          <div v-if="tape.expired" class="text-expired">
            <p v-html="tape.brand_channel.expirated_html"></p>
          </div>

          <BrandChannelPlayer v-else />
        </div>
        <div class="col-right">
          <BrandChannelContent />
        </div>
      </div>
    </section>
    <section v-else class="main-content clearfix">
      <div class="container">
        <div class="full" :style="`background: url(${brandChannel.background}) center center no-repeat;
            background-size: cover;
            `">
          <div v-if="tape.expired" class="text-expired">
            <p v-html="tape.brand_channel.expirated_html"></p>
          </div>

          <BrandChannelPlayer v-else />
        </div>
        <BrandChannelContent class="brand-channel-content-full" />
      </div>
    </section>
    <BrandChannelFooter />
  </div>
  <div v-else>
    <p>Carregando...</p>
  </div>
</template>

<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

body .col-right,
body .footer-left,
body .video-caption {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif !important;
  line-height: 1.5;
}

.clearfix:after {
  content: '';
  display: block;
  clear: both;
}

#ovm-player {
  position: relative;
  height: 560px;
  width: 315px;
  margin: 0 auto;
}

#ovm-player.horizontal {
  height: 340px;
  width: 100%;
}

iframe,
object,
embed {
  max-width: 100%;
}

.container {
  max-width: 995px;
  padding: 0 15px;
  margin: 0 auto;
}

.full {
  background-size: cover;
}

.banner {
  display: none;
  padding: 20px 0;
  text-align: center;
}

.banner-img {
  display: inline-block;
  width: 290px;
  height: 48px;
  background-size: cover;
}

.main-content {
  margin-top: 30px;
}

.col-left {
  float: left;
  width: 63%;
}

.col-right {
  float: right;
  width: 33%;
}

.footer-left {
  float: left;
  text-align: left;
  width: 49%;
}

.footer-right {
  float: right;
  text-align: right;
  width: 49%;
}

.footer {
  clear: both;
  text-align: right;
  margin: 30px 0;
  overflow: hidden;
}

.footer img {
  max-width: 120px;
}

.box-no-sessionid {
  height: 405px;
  width: 100%;
  background: #f5f5f5;
  background-size: 20%;
  text-transform: none;
  color: #999;
  letter-spacing: 0;
}

.brand-channel-content-full {
  padding: 10px 0;
}

@media screen and (max-width: 900px) {
  .box-no-sessionid {
    background-size: 30%;
    font-size: 18px;
  }
}

@media screen and (max-width: 965px) {
  #ovm-player.horizontal {
    height: 560px;
    width: 315px;
  }
}

@media screen and (max-width: 700px) {
  .container {
    padding: 0;
  }

  .brand-channel-content-full {
    padding: 20px 15px;
    text-align: center;
  }

  .full {
    background: none !important;
  }

  .header {
    padding: 10px;
  }

  .box-no-sessionid {
    background-position: center 30%;
    background-size: 20%;
    font-size: 18px;
    height: 220px;
    line-height: 230px;
  }

  .banner {
    display: block;
  }

  .col-left {
    width: 100%;
    padding: 0;
  }

  .col-right {
    width: 100%;
    padding: 20px 15px;
  }

  .footer {
    text-align: right;
    padding: 0 10px;
  }

  .footer-logo {
    width: 100%;
    text-align: center;
  }

  .footer img {
    max-width: 140px;
  }
}

@media screen and (max-width: 500px) {
  .box-no-sessionid {
    font-size: 14px;
    background-size: 35%;
  }

  .footer-left,
  .footer-right {
    float: none;
    width: 100%;
  }

  .footer-right {
    margin-top: 20px;
  }

  .header__logo {
    width: 100%;
    background-position: center center;
  }
}

.spinner {
  width: 70px;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -14px;
  margin-left: -35px;
}

.spinner>div {
  width: 18px;
  height: 18px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {

  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {

  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }

  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

#ovm-player .ovm-player-placeholder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}

#ovm-player>.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  z-index: 0;
}

#ovm-vi-thumbnail-overlay {
  background-color: rgba(0, 0, 0, 0) !important;
}

#ovm-player center#ovm-player-container {
  width: 100%;
  height: 100%;
}

#ovm-vi-interactive-root {
  overflow: hidden !important;
  position: relative;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0%;
  z-index: 2;
}

@font-face {
  font-family: 'Roboto', sans-serif;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-play:before {
  content: '\f101';
}

.vjs-icon-volume-mute {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-mute:before {
  content: '\f104';
}

.vjs-icon-volume-high,
.video-js .vjs-mute-control,
.video-js .vjs-volume-menu-button {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-volume-high:before,
.video-js .vjs-mute-control:before,
.video-js .vjs-volume-menu-button:before {
  content: '\f107';
}

.vjs-icon-replay {
  font-family: VideoJS;
  font-weight: normal;
  font-style: normal;
}

.vjs-icon-replay:before {
  content: '\f116';
}

.text-expired {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  color: #666;
  padding: 40px;
  line-height: 1.5em;
}
</style>
